import { ActionSource } from 'owa-mail-store';
import { isGuid } from 'owa-guid';
import { isFeatureEnabled } from 'owa-feature-flags';
import PersonaType from 'owa-service/lib/contract/PersonaType';

export default {
    RemoveFavoritePersonaAction: {
        name: 'RemoveFavoritePersonaAction',
        customData: (personaId: string, actionSource: ActionSource) => [actionSource],
    },

    AddFavoriteSearch: {
        name: 'AddFavoriteSearch',
        customData: (searchQuery: string, actionSource: ActionSource) => [
            actionSource,
            isFeatureEnabled('tri-favorites-roaming'),
        ],
    },

    RemoveFavoriteSearch: {
        name: 'RemoveFavoriteSearch',
        customData: (searchQuery: string, actionSource: ActionSource) => [
            actionSource,
            isFeatureEnabled('tri-favorites-roaming'),
        ],
    },

    AddFavoritePersonaAction: {
        name: 'AddFavoritePersonaAction',
        customData: (
            personaId: string | null,
            emailAddress: string | null,
            displayName: string,
            actionSource: ActionSource,
            valueForResolution: string,
            contactResolver: () => Promise<PersonaType | null>
        ) => [actionSource],
    },

    ValidateAndUpdateFavorite: {
        name: 'ValidateAndUpdateFavorite',
        customData: (
            currentNodeId: string,
            currentPersonaEmail: string,
            currentDisplayName: string
        ) => (isGuid(currentNodeId) ? [currentNodeId] : null),
    },

    DeleteFolderFailure: {
        name: 'DeleteFolderFailure',
        customData: (error: string) => [error],
    },

    OnFavoritePersonaSelectedAction: {
        name: 'OnFavoritePersonaSelectedAction',
    },

    OnFavoritePersonaUpdatedAction: {
        name: 'OnFavoritePersonaUpdatedAction',
    },

    InitializeFavoritePersonasAction: {
        name: 'InitializeFavoritePersonasAction',
    },

    OneOffAddressUsedForFavorite: 'OneOffAddressUsedForFavorite',
    OutlookFavoritePersonasLoaded: {
        name: 'OutlookFavoritePersonasLoaded',
    },
};
